module.exports = __webpack_public_path__ + "img/bannerOrange.7a15c8d7.jpg";